import { basicInitialState } from '../_utils/basicInitialState';
import { TSearchState } from './search';

export const searchInitialState: TSearchState = {
  ...basicInitialState,
  searchResults: [],
  searchQuery: ''
};
